import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";

const BestPriceGuaranteed = ({ marketingData = {} }) => {
    const { title = "", description = "", rateComparison = [] } = marketingData || {};

    if (!title || rateComparison.length === 0) {
        return null;
    }

    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.heading"}>{title.replaceAll("**", "")}</p>
            <p styleName={"styles.subHeading"}>{description}</p>
            <div styleName={"styles.boxOuter"}>
                <div styleName={"styles.sectionWrap"}>
                    <div styleName={"styles.leftSection"}>
                        <img src={rateComparison[0]?.iconUrl} />
                    </div>
                    <p styleName={"styles.logoPrice"}>${rateComparison[0]?.value}</p>
                </div>
                {rateComparison?.length > NUMBER.ONE && (
                    <div styleName={"styles.sectionWrap"}>
                        <div styleName={"styles.leftSection"}>
                            <p styleName={"styles.otherMechanics"}>{rateComparison[1]?.name}</p>
                        </div>
                        <p styleName={"styles.pinkPriceTab"}>${rateComparison[1]?.value}</p>
                    </div>
                )}
                {rateComparison?.length > NUMBER.TWO && (
                    <div styleName={"styles.sectionWrap"}>
                        <div styleName={"styles.leftSection"}>
                            <p styleName={"styles.otherMechanics"}>{rateComparison[NUMBER.TWO]?.name}</p>
                        </div>
                        <p styleName={"styles.manufacturer"}>${rateComparison[NUMBER.TWO]?.value}</p>
                    </div>
                )}
                <p styleName={"styles.costPerBasic"}>Cost per basic service</p>
            </div>
        </div>
    );
};

BestPriceGuaranteed.propTypes = {
    marketingData: PropTypes.object
};

export default BestPriceGuaranteed;
